export default  {
    component: 'alert_config',
    name: 'alert_config',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Device Type',
        param: 'device_type',
        type: 'text',
        required: true,
        identifier: true,
        description: `> 5 options available to configure alert
        - **communication** [Can be display as alert button in home dashboard]
        - **grid** [Can be display as alert button in home dashboard]
        - **inverter** [Can be display as alert button in home dashboard]
        - **scb** [Can be display as alert button in home dashboard]
        - **transformer** [Can be display as alert button in home dashboard]
        - **secondary_alert**
        - **dgr**`
      },
      {
        name: 'Alert Condition',
        param: 'alert_condition',
        type: 'text',
        description: `> TEP plants, for device type **"grid"** we add alert_condition as **"tep"**`

      },
      {
        name: 'Module',
        param: 'module',
        required: true,
        identifier: true,
        type: 'text',
        description: `> By default module should be added as **alert**`
      },
      {
        name: 'Source Info',
        param: 'source_info',
        type: 'json',
        description: `> Its added for grid alert
        - **{"src": "inv"}** [if source is inverter]
        - **{"src": "mfm", "ref_id": {"blockId": -, "feederId": -}}** [if source is mfm]
        - **{"src": "inv", "minCount": "2", "reading_time": {"startTime": "4", "offsetTime": "1"}}** [This is for old grid logic where source is inverter, and min count is considered as the minimum count which full fills the grid alert logic for which the dtaa has been fullfiled. Need to provide start time and offset time as end time ]
        - **{"src": "grid_alert"}**`
      },
      {
        name: 'Config',
        param: 'config',
        type: 'json'
      }
    ]
  }